import { formatResponse, getValue, isObject } from "@/shared/utils/helpers";
import { Customer, Statisctic } from "@/shared/utils/interfaces";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { get2 } from "../axios";

export interface Data {
  order_users: Customer[];
  statistics: {
    [key: number]: Statisctic[];
  }[];
}

const useCustomersHook = ({
  branch,
  pageNumber = 1,
  pageSize = 10,
  filters = {},
  enabled = false,
}) => {
  const getUsers = useQuery<Data>({
    queryKey: [
      "orders/users",
      branch,
      JSON.stringify(filters),
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      get2(`/v1/orders/users/${branch}`, {
        params: { ...filters, pageSize, pageNumber },
      }),
    enabled,
    placeholderData: keepPreviousData,
  });

  const data = useMemo<Customer[]>(() => {
    let orders = [];
    if (getUsers.data !== undefined) {
      getUsers.data?.order_users.forEach((order) => {
        let o = {};
        let statId = Object.keys(getUsers.data.statistics).find((key) => {
          return getValue(order.item_id) === parseInt(key);
        });
        const stats = getUsers.data.statistics[statId];
        Object.keys(order).forEach((key) => {
          o[key] = getValue(order[key]);
        });
        orders.push({ ...o, stats });
      });
    }
    return orders;
  }, [getUsers.data]);

  return { getUsers, data };
};

export default useCustomersHook;
